export const checkViewportWidthLessThan = (viewportWidth, breakPoint) => {
    return viewportWidth < breakPoint ? true : false
}

export const checkViewportWidthGreaterThan = (viewportWidth, breakPoint) => {
    return viewportWidth > breakPoint ? true : false
}